import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  pageTitle: {
    defaultMessage: 'Feature Management',
    id: 'qfkXOC',
    description: 'Title for feature management page',
  },
  pageDescription: {
    defaultMessage: 'Configure fraud detection rules to protect your business from fraudulent orders.',
    id: 'WYch36',
    description: 'Description for feature management page',
  },
  saveButton: {
    defaultMessage: 'Save Changes',
    id: '8q23LO',
    description: 'Button to save loss prevention settings',
  },
  cancelButton: {
    defaultMessage: 'Cancel',
    id: 'atWQKt',
    description: 'Button to cancel changes and reset form',
  },
  reprocessButton: {
    defaultMessage: 'Reprocess All Orders',
    id: 'tf3WKV',
    description: 'Button to trigger manual fraud reprocessing',
  },
  loadError: {
    defaultMessage: 'Failed to load loss prevention settings',
    id: 'TclN0v',
    description: 'Error message when loading settings fails',
  },
  saveSuccess: {
    defaultMessage: 'Loss prevention settings saved successfully',
    id: 'uxZQlU',
    description: 'Success message when settings are saved',
  },
  saveError: {
    defaultMessage: 'Failed to save loss prevention settings',
    id: 'ZTOybN',
    description: 'Error message when saving settings fails',
  },
});
